module.exports = __webpack_public_path__ + "static/media/c32.8dcbd7f0.png";